import React from 'react';
import { toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';


export const showToastError = (responseMessage: string) => {
  toast.error(responseMessage);
};

export const showToastSuccess = (responseMessage: string) => {
  toast.success(responseMessage);
};
